<template>
  <div
    class="card"
    :class="{
      selected: selected,
      single: single,
      grow: !single,
      list: list,
      find: find,
      highlight: actionRequested,
    }"
    @click="cardClicked"
  >
    <div class="content">
      <div class="cover">
        <img class="cover-image" :src="imageUrl" />
        <template v-if="user">
          <!-- <template v-if="!user.is_athlete"> -->
          <points :count="assignment.reward_points"></points>
          <!-- </template>
          <template v-else> </template> -->
        </template>
      </div>
      <div class="title">
        <div class="title-text" :title="book.title">
          {{ displayTitle }}
        </div>
        <div v-if="subtitle" class="subtitle-text">
          {{ subtitle }}
        </div>
        <div class="subcontent">
          <div class="genre">{{ book.genre.label }} <span class="subgenre" v-if="book.subgenre">({{ book.subgenre.label }})</span></div>
          <div class="clearfix"></div>
          <div class="word-count" v-if="book.explicit_content">
            Explicit Content
          </div>
        </div>
        <div class="clearfix"></div>

        <div v-if="assignment.is_pubby_prize" class="pubby-prize">
          <img
            src="/images/icons/further-prize.svg"
            class="icon-pubby-prize"
            alt="Your review won a Pubby Prize and earned an extra 300 snaps!"
          />
        </div>

        <template v-if="assignment.status === 'PendingApproval'">
          <div class="due-date due-pending-approval">Turned In</div>
        </template>
        <template v-else-if="assignment.status === 'Approved' || assignment.status === 'ActionApproved'">
          <div class="due-date due-completed">Completed</div>
        </template>
        <template v-else-if="assignment.status === 'Archived'">
          <div class="due-date due-changes-requested">
            Could Not Be Verified
          </div>
        </template>
        <template v-else-if="assignment.status === 'Rejected'">
          <div class="due-date due-changes-requested">Changes Requested</div>
        </template>
        <template v-else-if="assignment.status === 'ActionRequested'">
          <div class="due-date due-changes-requested">Action Requested</div>
        </template>
        <template v-else>
          <div v-if="assignment.is_verified" class="verified">
            <span class="verified-label">Requires Purchase</span>
            <span class="verified-price">{{
              getListingPrice(assignment)
            }}</span>
          </div>
          <div v-else-if="assignment.is_kindle" class="verified">
            <span class="verified-label">Requires</span>
            <span class="verified-price">Kindle Unlimited</span>
          </div>
          <div v-else class="free">
            <span class="free-label">Free Download</span>
            <span class="free-filetype">{{ getFiletype(assignment) }}</span>
          </div>
          <div class="due-date">

          <span :class="{'due-soon': dueSoon}">
            Due
            <span :class="{date: !dueSoon}">{{
              (assignment.due_at || assignment.proposed_due_at) | shortDate
            }}</span>
          </span>
            &nbsp;
            <span style="opacity: 0.7"
              >{{ book.word_count | bigNumber }} words</span
            >
            <!-- in
            <span
              class="date"
              :class="{speedy: assignment.upgrade_type === 'Speedy'}"
            >{{ dueInDays() }} days</span>-->
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Points from "@/components/Points/Tag";
import { mapActions, mapState } from "vuex";

export default {
  name: "Card",
  components: { Points },
  props: ["assignment", "selected", "single", "list", "find"],
  data: function () {
    return {
      book: this.assignment.book,
    };
  },
  computed: {
    ...mapState({
      user: "user",
    }),
    imageUrl: function () {
      return process.env.VUE_APP_S3_PATH + this.book.cover_file_url;
    },
    displayTitle: function () {
      var title = this.book.title;

      if (title.indexOf(":") > 0) {
        title = title.substring(0, title.indexOf(":"));
      }

      if (!this.single) {
        title = this.shortTitle(title);
      }

      return title;
    },
    subtitle: function () {
      var title = this.book.title;
      // console.log("subtitle title", title);

      if (title.indexOf(":") < 1) {
        // console.log("subtitle no colon");
        return null;
      }

      if (!this.single) {
        return this.shortSubtitle(title);
      }

      return title.substring(title.indexOf(":") + 1);
    },
    actionRequested() {
      return this.assignment.status === 'ActionRequested'
    }
  },
  methods: {
    shortTitle(title) {
      const length = this.list ? 68 : 68;

      if (title.length > length) {
        title = title.substring(0, length) + "...";
      }

      return title;
    },
    shortSubtitle(title) {
      var subTitle = title.substring(title.indexOf(":") + 1);
      var length = 94;

      // var mainTitle = this.book.title.substring(title.indexOf(":") + 1);
      // if (mainTitle.length > 68) {
      //   length = 68;
      // }

      if (subTitle.length > length) {
        subTitle = subTitle.substring(0, length) + "...";
      }

      return subTitle;
    },
    dueInDays() {
      const dueAt = this.assignment.due_at || this.assignment.proposed_due_at;

      const nowDate = new Date();
      const dueDate = new Date(dueAt);

      return Math.floor(
        (dueDate.getTime() - nowDate.getTime()) / (1000 * 3600 * 24)
      );
    },
    dueSoon() {
      const now = new Date()
      const dueDate = new Date(
        this.assignment.due_at.replace(/-/g, "/")
        );
        const startTime = dueDate.getTime() - dueDate.getTimezoneOffset() * 60 * 1000;

      const dueSoonCutoff = new Date(Math.round(
        (startTime - (24 * 60 * 1000))/(60*1000))*60*1000
      );

      return (now >= dueSoonCutoff); //(now <= dueDate) && 
    },
    cardClicked() {
      // console.log("cardClicked", this.list);
      if (this.list) {
        this.$router.push("/assignments/" + this.assignment.id);
      }
    },
    getListingPrice(assignment) {
      if (!assignment.is_verified || assignment.listing_price==null) {
        return null;
      }

      switch (assignment.listing_price) {
        case 0:
          return "Free Promotion";
        case 1:
          return "$0.99";
        case 2:
          return "$1.99";
        case 3:
          return "$2.99";
        case 4:
          return "$3.99";
        case 5:
          return "$4.99";
      }
    },
    getFiletype(assignment) {
      var manuscriptFileUrl = this.book.manuscript_file_url
      if (assignment.is_verified || !manuscriptFileUrl || !manuscriptFileUrl.includes('.')) {
        return null;
      }
      var fileExt = manuscriptFileUrl.split('.').pop();
      return fileExt;
    },
  },
  created() {
    if (this.assignment.due_at) {
      this.assignment.due_at = this.assignment.due_at.replace(/-/g, "/");
    }
    if (this.assignment.proposed_due_at) {
      this.assignment.proposed_due_at = this.assignment.proposed_due_at.replace(
        /-/g,
        "/"
      );
    }
  },
};
</script>

<style lang="scss" scoped>
.card {
  background: #fff;
  margin: 0 0 18px 0;
  padding: 12px 0;
  border-radius: 8px;
  font-family: "Source Sans Pro";
}
.card:hover {
  cursor: pointer;
}
.card.single:hover,
.card.list:hover {
  border: 0 !important;
  border-radius: 16px;
  cursor: pointer;
}

.card.list {
  border: 0px !important;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);

  .due-date {
    padding: 8px 0 0 2px;
  }

  .verified {
    padding-top: 6px;
    padding-bottom: 0;
  }
}

.highlight {
  box-shadow: 0px 1px 0.5rem $color-red !important;
}

.free {
  margin-top: -1px;
  padding-bottom: 5px;
  font-family: $font-family;
  font-size: 13.5pt;

  .free-label {
    margin-top: 0px;
    padding-left: 1px;
    padding-right: 4px;
    font-size: 12pt;
    font-weight: 600;
    color: #888;
    font-family: "Source Sans Pro";
  }

  .free-filetype{
    margin-top: 0px;
    padding-left: 1px;
    font-size: 12pt;
    font-weight: 600;
    color: #0053E0;
    font-family: "Source Sans Pro";
  }
}

.card.find {
  margin: 0 5px !important;
  margin-bottom: 12px !important;
  padding-bottom: 10px !important;
  border-radius: 16px;
  border: 3px solid #fff !important;
  min-height: 218px !important;

  .title-text {
    color: $color-blue !important;
    font-weight: 600 !important;
    font-size: 15.5pt !important;
    padding-right: 2px !important;
  }

  .verified {
    padding-bottom: 7px !important;
  }

  // .cover {
  //   min-width: 104px;
  //   flex-basis: 104px;
  //   flex-grow: 0;
  // }

  // .cover-image {
  //   width: 84px;
  //   margin: 0 2px;
  //   border-radius: 3px;
  // }
}
.card.find:hover {
  border-radius: 16px;
  border: 3px solid #f1f1f1 !important;
}
.card.find.selected {
  border-radius: 16px;
  background: lighten($color-blue, 46%);
  border: 3px solid lighten($color-blue, 32%) !important;
}

.find {
  .subcontent {
    display: block;
  }
  .genre {
    display: inline-block;
    padding-top: 2px;
    padding-bottom: 4px;
  }
  .subgenre {
    opacity: 0.7;
    font-size: 90%;
  }
  .word-count {
    padding-left: 0;
    padding-top: 9px;
    padding-bottom: 9px;
  }
}

.grow {
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.single {
  zoom: 1.2;
  box-shadow: none !important;
  border: 0 !important;
  padding: 0 0 8px 0 !important;
  margin: 0px 0 0 0 !important;

  .content {
    padding: 0 !important;
  }

  .title-text {
    padding-right: 1em;
    font-size: 20pt !important;
  }

  .title {
    padding-left: 20px !important;
  }

  .cover {
    min-width: 108px;
    flex-basis: 108px;
    flex-grow: 0;
  }

  .cover-image {
    width: 104px;
    margin: 0 2px;
    border-radius: 3px;
  }

  .genre {
    // float: left;
    // margin-bottom: 4px;
    // padding-top: 6px;
  }

  .word-count {
    float: left;
    padding: 13px 0 9px 11px;
  }

  .due-date {
    padding-top: 8px;
  }

  .verified {
    //padding-top: 6px;
    padding-bottom: 0;
  }
}

.content {
  display: flex;
  padding: 8px 8px 0px 8px;
}

.cover {
  flex-basis: 140px;
  flex-grow: 0;
}

.cover-image {
  width: 100px;
  margin: 0 18px;
  border-radius: 3px;
}

.title {
  flex-grow: 1;
  letter-spacing: 0 !important;
}

.title-text {
  padding-top: 6px;
  padding-bottom: 3px;
  padding-right: 20px;
  line-height: 1.15em;
  font-size: 20pt;
  font-weight: 700;
  color: $color-blue;
  letter-spacing: 0 !important;
  font-family: "Source Sans Pro";
}

.subtitle-text {
  padding-top: 0px;
  padding-bottom: 4px;
  padding-right: 20px;

  padding-left: 0px;
  line-height: 1.2em;
  font-size: 12pt;
  font-weight: 600;
  color: darken($color-blue, 2%);
  letter-spacing: 0px !important;
  //text-transform: uppercase;
  font-family: "Source Sans Pro";
}

.subcontent {
  display: flex;
  padding-bottom: 3px;
}

.genre {
  padding-top: 4px;
  padding-bottom: 6px;
  margin-top: 6px;
  border-radius: 4px;
  font-size: 12pt;
  font-weight: 600;
  letter-spacing: 0px;
  color: #555;
  font-family: "Source Sans Pro";
}

.word-count {
  padding: 11px 0 0 9px;
  font-size: 11.5pt;
  font-weight: 600;
  color: #999;
  font-family: "Source Sans Pro";
}
.word-count .label {
  padding-right: 0.5em;
  color: #888;
  font-weight: 700;
}

.speedy-tag {
  display: flex;
  align-items: center;
  padding: 8px 0 0 0;
  font-family: "Source Sans Pro";
  color: #ef6c00;
}
.find .speedy-tag {
  padding: 4px 0 4px 0;
}
.speedy-icon {
  float: left;
  font-size: 10pt !important;
}
.speedy-label {
  float: left;
  padding-left: 4px;
  font-size: 13pt !important;
  font-weight: 700;
}

.due-date {
  margin-top: 0px;
  padding-left: 1px;
  font-size: 12pt;
  font-weight: 600;
  color: #888;
  font-family: "Source Sans Pro";
}
.date {
  font-weight: 600;
  color: #4caf50;
}
.date.speedy {
  color: lighten(#ef6c00, 6%);
}

.due-pending-approval {
  color: #4caf50 !important;
}
.due-completed {
  color: $color-blue;
}
.due-changes-requested {
  color: darken(#b59505, 0%) !important;
}

.due-soon {
  display: inline-block;
  color: $color-red;
  animation: pulse 2s infinite;
}

.verified {
  margin-top: -1px;
  padding-bottom: 5px;
  font-family: $font-family;
  font-size: 13.5pt;

  .verified-label {
    margin-top: 0px;
    padding-left: 1px;
    padding-right: 4px;
    font-size: 12pt;
    font-weight: 600;
    color: #888;
    font-family: "Source Sans Pro";
  }
  .verified-price {
    margin-top: 0px;
    padding-left: 1px;
    font-size: 12pt;
    font-weight: 600;
    color: #e08d00;
    font-family: "Source Sans Pro";
  }
}

.reading-credit {
  background: #e1f5fe;
  border-radius: 100px;
  width: 100px;
  margin: 0 auto;
  margin-top: 4px;
  padding: 4px 0;
  font-size: 13pt;
  font-weight: 600;
  color: $color-blue;
  text-align: center;
}

@media (max-width: 1024px) {
  .card {
    margin-bottom: 0px !important;
    min-height: 140px;

    .title {
      padding-left: 0 !important;
    }

    .title-text {
      font-size: 17pt !important;
      padding-right: 0 !important;
    }
  }

  .single {
    zoom: 1 !important;

    .title-text {
      font-size: 17pt !important;
      padding-right: 0 !important;
    }

    .cover-image {
      width: 90px !important;
      margin: 0 0px !important;
      margin-left: 2px !important;
      margin-top: 2px !important;
    }
  }

  .cover {
    flex-basis: 110px !important;
    min-width: 110px !important;
    flex-grow: 0 !important;
  }

  .cover-image {
    width: 80px !important;
    margin: 0 11px !important;
    margin-top: 2px !important;
  }
}

.pubby-prize {
  float: left;
  margin: 9px 4px 0 2px;
}
.icon-pubby-prize {
  width: 25px;
}
</style>


